/* Core & libraries */
import React, { useEffect } from "react";
import * as Sentry from '@sentry/react';

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import { ME_ENDPOINT } from "../endpoints/endpoints";
import { useLocaleContext, useLocaleUpdateContext } from "../contexts/localeContext";
import { useUserContext, useUserUpdateContext } from "../contexts/userContext";
import { getDefaultLocale, injectDomainRelatedScripts } from "../helpers/general";
import { ACCEPTED_LANGUAGES, DEFAULT_LOCALE } from '../constants/appConstants';

/* Components */
/* Styles */

export const useUserService = () => {
  const setLocaleContext = useLocaleUpdateContext();
  const locale = useLocaleContext();
  const setUserContext = useUserUpdateContext();
  const userContext = useUserContext();
  const { genericApiFetch } = useGenericApiFetch();

  useEffect(() => {
    if (!userContext) {
      (async () => {
        await getUserDetails();
      })();
    }
  }, []);

  const getUserDetails = async () => {
    const response = await genericApiFetch({
      url: ME_ENDPOINT,
      method: "GET",
    });

    if (response.success) {
      setUserContext(response.data)
      const locale = response?.data?.userInfo?.locale
      const airline = response?.data?.userInfo?.providerInfo?.providerCode;

      // set locale in context with the locale received from BE
      if (locale && ACCEPTED_LANGUAGES[locale]) {
        setLocaleContext(locale);
      } else {
        setLocaleContext(getDefaultLocale(airline));
      }

      //inject specific scripts
      if (airline) {
        Sentry.setTag("airline", airline);
        injectDomainRelatedScripts(airline, locale)
      }

      return true;
    }
    return false
  };

  return {
    userDetails: userContext,
    getUserDetails
  };
}

